// extracted by mini-css-extract-plugin
export default {"MyPageContainer":"myPage_MyPageContainer__9mf8Z","MyPageBannerContainer":"myPage_MyPageBannerContainer__TP63i","marginBottom1":"myPage_marginBottom1__gcFAY"};